export default function (context, val) {
    if (val === context.state.system.code && context.state.form.AgreementCodes.length > 1) {
        context.state.form.AgreementCodes.splice(context.state.form.AgreementCodes.indexOf(val), 1);
        context.state.agreements.list.splice(context.state.agreements.list.indexOf(context.getters['agreements/item'](val)), 1);
        context.commit('set_system', {code: context.state.form.AgreementCodes[0]});
    } else {
        context.state.form.AgreementCodes.splice(context.state.form.AgreementCodes.indexOf(val), 1);
        context.state.agreements.list.splice(context.state.agreements.list.indexOf(context.getters['agreements/item'](val)), 1);
    }
}